module.exports = __webpack_public_path__ + "static/media/login-team.ba4d551d.jpg";